import React, {useEffect, useState} from 'react';
import Slider from "react-slick";
import toast, { Toaster } from 'react-hot-toast';
import icon_color from '../../../assets/images/icon_color1.svg'
import icon_recommend from '../../../assets/images/ico_recommend.svg'
import { delMycorpAPI, addMycorpAPI, getRecommendCorpAPI} from "../../../apis/my_service";

const MycorpList = ({myCorpClick, corpList, count}) => {
    const settings = {
        dots: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        speed: 500,
        initialSlide: 0,
        infinite:false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    dots: false
                }
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: false
                }
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: false
                }
            },
            {
                breakpoint: 390,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                }
            },
        ],
        appendDots: (dots) => (
            <div
                style={{
                    width: '100%',
                    position: 'absolute',
                    bottom: '-34px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <ul> {dots} </ul>
            </div>
        ),
        dotsClass : 'dots_custom'
    };

    const [recommendCorp, setRecommendCorp] = useState([])//추천종목 목록
    const [recommendCnt, setRecommendCnt] = useState(30-count)//추천종목 갯수

    const notify = (msg) => toast.success(msg);

    //추천종목 목록 조회
    const getRecommendCorpData = () => {getRecommendCorpAPI(recommendCnt,'POPULAR').then(res=> setRecommendCorp(res))}

    useEffect(getRecommendCorpData, [recommendCnt])

    const subscribeBtnClick = (stockcode,stockname, subscribe) => {
        if(subscribe){
            delMycorpAPI(stockcode).then(() => {
                notify('마이기업 삭제가\n 완료 되었습니다.')
            })
        }else {
            addMycorpAPI(stockcode).then((res) => {
                if(res){ 
                    notify(stockname + ' 이/가 마이기업으로\n등록 되었습니다.\nAI 콴의 다양한 뉴스 분석 콘텐츠를\n 확인해보세요!')
                } else {
                    notify(stockname + ' 이/가 이미 존재합니다!')
                }
            })
        }
        window.location.replace('/mycorp')
    }


    //마이종목 카드 컴포넌트
    const CorpCard = ({corp, subscribe}) => {
        const price = Number(corp.quotesinfo.stockquotes).toLocaleString()
        const percent = corp.quotesinfo.gappercent > 0 ? 'positive' : 'negative'
        return (
            <div className='myCard_container'>
                {!subscribe && <img className='icon_recommend' src={icon_recommend} alt='reccmmend'/>}
                <div  onClick={()=> {
                    if(subscribe){
                        myCorpClick(corp.stockcode, corp.stockname)
                    }
                }}>
                    <img className='icon_color' src={icon_color} alt='stock_logo'/>
                    <p className='stockname'>{corp.stockname}</p>
                    <p className={`stockprice ${percent}`}>{`${price} ${corp.quotesinfo.gappercent}`}</p>
                </div>
                <button
                    className={subscribe? 'subscribed_btn': ''}
                    onClick={()=> subscribeBtnClick(corp.stockcode, corp.stockname, subscribe)}>{subscribe ? '구독취소' : '구독하기'}</button>
            </div>
        )
    }

    return (
        <div className='corp_list_container'>
            <div className='inner_container'>
                <Toaster
                    toastOptions={{style:{ padding: '16px', fontSize: '17px',display:'inline-block', textAlign:'center', lineHeight:'1.6'}}}
                    containerStyle={{top: 140,}}/>
                <p className='title_sm'> 마이기업 리스트 ({corpList.length}/30)</p>
                <Slider {...settings}>
                    <div className='myCard_container' onClick={(e)=>myCorpClick(e.target.id)}>
                        <p className='stockname mycorp_total'>마이기업 전체</p>
                    </div>
                    {recommendCorp && corpList && corpList.map(corp => <CorpCard key={corp.stockcode} corp={corp} subscribe={true}/>)}
                    {recommendCorp && recommendCorp.map(corp => <CorpCard key={corp.stockcode} corp={corp} subscribe={false}/>)}
                </Slider>
            </div>
        </div>

    );
};

export default MycorpList;